const ActionPlans = {
  ACTION_PLAN_ADDING: 'action_plan/adding',
  ACTION_PLAN_EDIT: 'action_plan/edit',
  ACTION_PLAN_DELETE: 'action_plan/delete',
  ACTION_PLAN_TERMINATE: 'action_plan/terminate',
  ACTION_PLAN_REOPEN: 'action_plan/reopen',
}

export default ActionPlans;
